export const TEST_ID = 'expiredPill';
